import { EMerchantReportFrequency } from '@src/data/types/Constants'
import { Merchant } from '@src/data/types/Merchant'
import { UpdateMerchantDto } from '@src/data/api/merchants-api/merchants-api'

/**
 * Builds a full `UpdateMerchantDto` from the current `merchant` baseline, with a
 * tab's slice applied on top via `overrides`.
 *
 * `PUT /Merchants/{id}` has no partial-update variant — it always takes the
 * whole DTO spanning every tab. Since each tab can only be saved while the
 * others are pristine (the MultiFormTabs dirty guard blocks switching otherwise),
 * reading the non-edited fields straight from `merchant` is always correct.
 */
export function buildUpdateMerchantDto(merchant: Merchant, overrides: Partial<UpdateMerchantDto>): UpdateMerchantDto {
  return {
    merchantId: merchant.id,
    territoryId: merchant.territoryId,
    noPaymentPolicy: merchant.noPaymentPolicy,
    hideAddress: merchant.hideAddress,
    canSkipFlinks: merchant.canSkipFlinks,
    canPayBorrowers: merchant.canPayBorrowers,
    canAcceptHighEstimate: merchant.canAcceptHighEstimate,
    showInterestRateOnMerchantDashboard: merchant.showInterestRateOnMerchantDashboard,
    automaticIncomeApproval: merchant.automaticIncomeApproval,
    allowCoApplicant: merchant.allowCoApplicant ?? true,
    planPromoRules: merchant.planPromoRules,
    tags: merchant.tags,
    reportGenerationFrequency: merchant.reportGenerationFrequency || EMerchantReportFrequency.never,
    reportRecipientsEmailList: merchant.reportRecipientsEmailList,
    rateAgreements: merchant.rateAgreements,
    financingProgramConfigs: merchant.financingProgramConfigs ?? [],
    minimumApplicationStarPlan: merchant.minimumApplicationStarPlan,
    flashPlanDefinedInManageMerchant: merchant.flashPlanDefinedInManageMerchant ?? false,
    promoNotificationEmailList: merchant.promoNotificationEmailList ?? [],
    ...overrides,
  }
}
